import { type SupportedIntegrationSyncTypes } from '#shared/lib/integrations';
import {
    updateIntegrationSettingsOrders,
    updateIntegrationSettingsPrices,
    updateIntegrationSettingsProducts,
    updateIntegrationSettingsStocks,
} from '../api';

export const ENDPOINT_UPDATE_INTEGRATION_SETTINGS: Record<
    SupportedIntegrationSyncTypes,
    | typeof updateIntegrationSettingsOrders
    | typeof updateIntegrationSettingsPrices
    | typeof updateIntegrationSettingsProducts
    | typeof updateIntegrationSettingsStocks
    | typeof updateIntegrationSettingsProducts
> = {
    products: updateIntegrationSettingsProducts,
    stocks: updateIntegrationSettingsStocks,
    orders: updateIntegrationSettingsOrders,
    prices: updateIntegrationSettingsPrices,
    mc_feed: updateIntegrationSettingsProducts,
};
